export const isLocalEnv = () => {
  try {
    // @ts-ignore env
    return __HOST_LOCAL__ || __HOST_TEST__;
  } catch {
    return false;
  }
};

export const isBuildIn = () => {
  try {
    // @ts-ignore env
    return __BUILD_IN__;
  } catch {
    return false;
  }
};
export const getStripePublicKey = () => {
  // @ts-ignore env
  return import.meta?.env?.VITE_CDN_HOST;
};

export const buildLanguageIsZh = () => {
  try {
    // @ts-ignore env
    return __LOCALE__ === 'zh' || __LOCALE__ === 'tc';
  } catch {
    return false;
  }
};

export const isPrivate = () => {
  try {
    // @ts-ignore env
    return __PRIVATE__;
  } catch {
    return false;
  }
};

export const getCdnHost = () => {
  try {
    // @ts-ignore env
    if (import.meta?.env?.VITE_CDN_HOST) {
      // @ts-ignore env
      return import.meta?.env?.VITE_CDN_HOST;
    }
    // @ts-ignore env
    return isBuildIn() ? 'https://cdn2.buildin.ai/' : 'https://cdn2.flowus.cn/';
  } catch {
    return '';
  }
};

export const commonInjector = {
  isBuildIn: isBuildIn(),
  // @ts-ignore env
  cdnHost: getCdnHost(),
  languageIsZh: buildLanguageIsZh(),
};

export const commonInit = (params: Partial<typeof commonInjector>) => {
  Object.assign(commonInjector, params);
};
